import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.141 7.36a.75.75 0 0 1 0 1.281l-4.5 2.75A.752.752 0 0 1 5.5 10.75V5.221a.74.74 0 0 1 .384-.625.69.69 0 0 1 .756.013ZM6.5 5.696v4.606l3.772-2.331ZM0 8a8 8 0 1 1 8 8 8 8 0 0 1-8-8m8 7a7 7 0 1 0-7-7 7 7 0 0 0 7 7" }, null, -1)
  ])))
}
export default { render: render }